import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@store/Framework/Common/Utilities/breakpointValues";
import Styleguide from "@store/Framework/Types/Styleguide";
import ArrowiOSDownward from "@store/Library/Components/Icons/ArrowiOSDownward";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        /* Store Custom Code - Start */
        background-color: ${getColor("common.background")};
        border: 0;
        border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
        /* Store Custom Code - End */
        color: ${getColor("text.main")};
        transition: ${transitionHoverStyles("background-color", "color", "border-color")};

        ${({ theme }) => css`
            ${breakpointValues(theme.design.accordion.padding.vertical, ["padding-top", "padding-bottom"])}
            ${breakpointValues(theme.design.accordion.padding.horizontal, ["padding-right", "padding-left"])}
            font-size: ${theme.design.typography.size.small};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            /* Store Custom Code - Start */
            background-color: ${getColor("common.accentContrastLight")};
            color: ${getColor("text")};
            border-color: transparent;
            /* Store Custom Code - End */
            border-bottom-color: transparent;
        }

        &:hover {
            /* Store Custom Code - Start */
            background-color: ${getColor("common.accentContrastLight")};
            border-bottom: ${pxToRem(1)} solid ${getColor("common.accentContrastLight")};
            /* Store Custom Code - End */
        }

        ${breakpoint("md")} {
            font-size: ${x => x.theme.design.typography.size.base};
        }

        ${breakpoint("lg")} {
            font-size: ${x => x.theme.design.typography.size.large};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

const accordion: Styleguide["accordion"] = {
    sectionDefaultProps: {
        headerProps: {
            css: css`
                ${_headerButtonStyles()}

                ${AccordionSectionPanel} + && {
                    ${_headerButtonStyles()}
                    ${({ theme }) => css`
                        ${breakpointValues(theme.design.accordion.spacing, "margin-top")}
                    `}
                }
            `,
        },
        panelProps: {
            css: css`
                ${({ theme }) => css`
                    ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                    ${breakpointValues(theme.design.accordion.padding.vertical, "padding-top")}
                `}
                background-color: ${getColor("common.background")};
                /* Store Custom Code - Start */
                border: none;
                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
                /* Store Custom Code - End */
                border-top: none;
            `,
        },
        toggleIconProps: {
            src: ArrowiOSDownward,
            color: "inherit",
            css: css`
                width: 1.3em;
                height: 1em;
                margin: 0 -0.2em 0 0.25em;
            `,
        },
        titleTypographyProps: null as any,
        toggleTransition: {
            transitionCss: css`
                transition: none;
            `,
            timeout: { enter: 0, exit: 0 },
        },
    },
};

export default accordion;
